export default __webpack_public_path__ + "static/media/tfosqp2.d0327492.webp";